import React from "react";
import ClientSideOnly from "./ClientSideOnly";
import ErrorBoundary from "./ErrorBoundary";
import StrictModeHandler from "./StrictModeHandler";

// Create a single SafetyWrapper component that combines all three
const SafetyWrapper = ({ children, loadingFallback }) => (
  <ErrorBoundary>
    <StrictModeHandler>
      <ClientSideOnly fallback={loadingFallback}>{children}</ClientSideOnly>
    </StrictModeHandler>
  </ErrorBoundary>
);

export { ClientSideOnly, ErrorBoundary, StrictModeHandler, SafetyWrapper };
export default SafetyWrapper;
